<template>
  <ResultTemplate>
    <TheListTitle prefix="search" />
    <HeaderTab
      :searchKey="searchKey"
      @onChangeTab="handleChangeTab"
      :result="searchResult"
    />
    <AccesskeyLink
      id="mainContent"
      class="accesskey-c"
      accesskey="C"
      title=":::主要內容顯示區"
    />
    <ArticleRelatedFields>
      <!-- 藝品導覽 -->
      <ArticleRelatedField
        :hasEmptyPage="true"
        displayType="card"
        linkPath="artwork"
        :titleImage="{ src: 'artwork-title', alt: '藝品導覽', mode: 'thick' }"
        :fieldData="searchResult.artworks"
        v-if="selectTab === 'artwork'"
      />
      <!-- 參觀總覽 -->
      <ArticleRelatedField
        :hasEmptyPage="true"
        displayType="card"
        linkPath="temple"
        :titleImage="{
          src: 'home-title-temple',
          alt: '參觀總覽',
          mode: 'thick',
        }"
        :fieldData="searchResult.temples"
        v-if="selectTab === 'temple'"
      />
      <!-- 旅遊導覽 -->
      <ArticleRelatedField
        :hasEmptyPage="true"
        displayType="card"
        linkPath="theme"
        :titleImage="{ src: 'theme-title', alt: '旅遊導覽', mode: 'thick' }"
        :fieldData="searchResult.themes"
        v-if="selectTab === 'theme'"
      />
      <!-- 圖鑑集 -->
      <ArticleRelatedField
        :hasEmptyPage="true"
        displayType="album"
        linkPath="album"
        :titleImage="{ src: 'more-albums', alt: '圖鑑集', mode: 'medium' }"
        :fieldData="searchResult.albums"
        v-if="selectTab === 'album'"
      />
    </ArticleRelatedFields>
  </ResultTemplate>
</template>

<script>
// import { lazyloading } from '@/utils/lazyloading';
import { getArticleString } from "@/config/articleString";
import TheListTitle from "@/components/list/TheListTitle";
import ResultTemplate from "@/components/ResultTemplate";
import ArticleRelatedFields from "@/components/article/ArticleRelatedFields";
import ArticleRelatedField from "@/components/article/ArticleRelatedField";
import HeaderTab from "@/components/HeaderTab";
import AccesskeyLink from "@/components/a11y/AccesskeyLink.vue";

export default {
  name: "SearchResults",
  metaInfo() {
    return {
      title: "搜尋結果",
      meta: [
        {
          vmid: "og:url",
          property: "og:url",
          content: this.productionWholeReference,
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: `臺南宗教藝術-${this.$route.params.keyword}的相關內容`,
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: `您搜尋「${this.$route.params.keyword}」的相關標籤資訊在這裡喔。`,
        },
      ],
    };
  },
  data() {
    return {
      selectTab: "artwork",
    };
  },
  computed: {
    searchResult() {
      return this.$store.getters.searchResult;
    },
    productionWholeReference() {
      return `${this.$store.getters.productionHostname}${window.location.pathname}${window.location.search}`;
    },
    searchKey() {
      return this.$route.params.keyword;
    },
  },
  async mounted() {
    await this.getSearchResult(this.$route.params.keyword);
    // await lazyloading();
  },
  async beforeRouteUpdate(to, from, next) {
    if (to.params.keyword !== from.params.keyword) {
      await this.getSearchResult(to.params.keyword);
      // await lazyloading();
    }
    next();
  },
  methods: {
    fixedEncodeURIComponent(str) {
      return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
        return "%" + c.charCodeAt(0).toString(16);
      });
    },
    async getSearchResult(keyword) {
      try {
        await this.$store.dispatch(
          "getSearchResult",
          this.fixedEncodeURIComponent(keyword)
        );
      } catch (e) {
        console.error(e);
      }
    },
    handleChangeTab(key) {
      this.selectTab = key;
    },
  },
  components: {
    TheListTitle,
    ResultTemplate,
    ArticleRelatedFields,
    ArticleRelatedField,
    HeaderTab,
    AccesskeyLink,
  },
};
</script>

<style lang="scss" scoped>
/deep/.related-field__title {
  display: none;
}
</style>
